import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  Grid,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const SectionBox = ({ title, children, onEdit }) => (
  <Card
    variant="outlined"
    sx={{
      mb: 3,
      borderRadius: 2,
      boxShadow: 1,
      position: "relative",
    }}
  >
    <CardContent>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          mb: 1,
        }}
      >
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onEdit} size="small">
          <EditIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box>{children}</Box>
    </CardContent>
  </Card>
);

const KitchenReview = ({ kitchenData, handleEdit }) => {
  return (
    <Box
      sx={{
        px: { xs: 2, sm: 4, md: 6 },
        py: 4,
        maxWidth: "1000px",
        mx: "auto",
      }}
    >
      <Typography variant="h5" sx={{ mb: 4, textAlign: "center" }}>
        Review Kitchen Listing
      </Typography>

      <SectionBox title="Kitchen Details" onEdit={() => handleEdit(1)}>
        <Typography>
          <strong>Title:</strong> {kitchenData.title}
        </Typography>
        <Typography>
          <strong>Category:</strong> {kitchenData.category}
        </Typography>
        <Typography>
          <strong>Size:</strong> {kitchenData.size}
        </Typography>
      </SectionBox>

      <SectionBox title="Location" onEdit={() => handleEdit(2)}>
        <Typography>
          <strong>Address:</strong> {kitchenData.address}
        </Typography>
      </SectionBox>

      <SectionBox title="Pricing" onEdit={() => handleEdit(3)}>
        <Typography>
          <strong>Hourly Rate:</strong> ${kitchenData.hourlyRate}
        </Typography>
        <Typography>
          <strong>Daily Rate:</strong> ${kitchenData.dayRate}
        </Typography>
        <Typography>
          <strong>Cleaning Fee:</strong> ${kitchenData.cleaningFee}
        </Typography>
        <Typography>
          <strong>Minimum Booking:</strong> {kitchenData.minBooking} hrs
        </Typography>
        <Typography>
          <strong>Security Deposit:</strong> ${kitchenData.securityDeposit}
        </Typography>
      </SectionBox>

      <SectionBox title="Images" onEdit={() => handleEdit(4)}></SectionBox>

      <SectionBox title="Documents" onEdit={() => handleEdit(5)}></SectionBox>

      <SectionBox title="Amenities" onEdit={() => handleEdit(6)}></SectionBox>
    </Box>
  );
};

export default KitchenReview;
